/* global axios */
import ApiClient from './ApiClient';

class TaskSubtasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  list(taskId) {
    return axios.get(`${this.url}/${taskId}/subtasks`);
  }

  create(taskId, payload) {
    return axios.post(`${this.url}/${taskId}/subtasks`, payload);
  }

  update(taskId, id, payload) {
    return axios.patch(`${this.url}/${taskId}/subtasks/${id}`, payload);
  }

  remove(taskId, id) {
    return axios.delete(`${this.url}/${taskId}/subtasks/${id}`);
  }

  toggle(taskId, id) {
    return axios.post(`${this.url}/${taskId}/subtasks/${id}/toggle`);
  }
}

export default new TaskSubtasksAPI();
